var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"home"}},[_c('h1',{staticClass:"px-7"},[_vm._v("Profile")]),(!_vm.isContentLoading)?_c('v-layout',[_c('v-container',{attrs:{"id":"home"}},[_c('agent-info-card',{attrs:{"item":_vm.agent}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }